<script>
import {Swiper, SwiperSlide, directive} from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {}
  },
}
</script>

<template>
  <div class="IschemicHeartDisease">
    <div class="IschemicHeartDisease__banner">
      <div class="IschemicHeartDisease__wrapper container">
        <div class="left">
          <h1 class="IschemicHeartDisease__banner--title">Кардіологія</h1>
        </div>
        <div class="right">
          <img class="img-desc" src="@/assets/img/MyocardialInfarction/main.svg" alt="banner">
          <img class="img-mob" src="@/assets/img/MyocardialInfarction/main-mob.svg" alt="">
        </div>
      </div>
    </div>

    <section class="section section2">

      <div class="container">
        <div class="section2__col">
          <h1>Ішемічна хвороба серця</h1>
          <p>Ішемічна хвороба серця — це стан
            порушеного кровопостачання серця у зв’язку
            з ураженням коронарних артерій (судин, що
            доставляють у серце насичену киснем кров).</p>
          <p>Причиною ураження коронарних
            артерій є атеросклероз — хронічне
            захворювання, що супроводжується
            відкладенням холестерину в бляшки
            на внутрішній поверхні судин. Бляшки
            поступово перекривають просвіт
            судин, порушують кровообіг і врешті-решт призводять до виникнення
            інфарктів та інсультів.</p>
        </div>
        <div class="section2__img">
          <img src="@/assets/img/IschemicHeartDisease/section2_img.png" alt="thrombus">
        </div>
      </div>
    </section>

    <section class="section section3">
      <div class="container">
        <div class="section3__img">
          <img src="@/assets/img/IschemicHeartDisease/section3_img.png" alt="thrombus">
        </div>
        <div class="section3__col section3__col--right">
          <h1>Чому виникає<br>атеросклероз<br>
            і як він
            лікується?</h1>
          <p>Є різні фактори, що призводять до розвитку атеросклерозу. Насамперед це надмірне вживання продуктів, що
            містять насичені жири та легкозасвоювані вуглеводи,
            куріння, зловживання алкоголем, застосування деяких
            лікарських засобів без рекомендацій лікаря. Важливу
            роль у розвитку атеросклерозу відіграє спадковість: всі
            особливості перебігу біохімічних процесів, зокрема, й
            обмін ліпідів, «закодовані» в наших генах.</p>
          <p>На жаль, ураження судин внаслідок атеросклерозу
            найчастіше має незворотний характер. Але важливо
            знати, що сьогодні є фармацевтичні препарати, які здатні
            істотно загальмувати прогресування атеросклерозу.</p>
        </div>
      </div>
    </section>

    <section class="section section4">
      <div class="container">

        <div class="section4__col section4__col--left">
          <h3>Програма «ТерапіяПЛЮС»</h3>
          <p>Дія програми підтримки пацієнтів «ТерапіяПЛЮС» поширюється на оригінальні* препарати для лікування
            серцево-судинних захворювань, таких як інфаркт міокарда, дисліпідемія, ішемічна хвороба серця та серцева
            недостатність.</p>
          <p><span>Якщо у вас діагностували серцево-судинне захворювання</span><br>
            Досягнення успіху в лікуванні та поліпшенні загального самопочуття неможливі без вашого бажання, сили духу
            та
            самоконтролю. Тому необхідно чітко дотримуватися рекомендацій лікаря, проходити всі призначені обстеження і
            контролювати результати лікування.</p>
        </div>
        <div class="section4__col section4__col--right">
          <h4>Основні умови лікування
            серцево-судинних захворювань:</h4>

          <div class="section4__row">
            <div class="section4__listItem">
              <svg viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_30_1240)">
                  <circle cx="48" cy="48" r="47.5" stroke="#3C1053"/>
                </g>
                <circle cx="48" cy="48" r="42.5" fill="#FFD770" stroke="#3C1053"/>
                <path
                    d="M50.2149 67.3312L24.5365 45.457C24.2148 45.1829 24.1001 44.7362 24.2499 44.3411L28.9727 31.8903C29.2246 31.2263 30.0689 31.0291 30.5888 31.5128L50.3174 49.8651C50.7019 50.2227 51.2975 50.2221 51.6812 49.8636L87.3173 16.572C87.9564 15.9749 89 16.4281 89 17.3027V20.1492C89 20.3763 88.9227 20.5966 88.7809 20.7739L51.6443 67.1947C51.2917 67.6354 50.6445 67.6972 50.2149 67.3312Z"
                    fill="white" stroke="#3C1053"/>
                <defs>
                  <clipPath id="clip0_30_1240">
                    <rect width="48" height="96" fill="white"/>
                  </clipPath>
                </defs>
              </svg>

              <p>Систематичний прийом
                призначених
                препаратів</p>
            </div>
            <div class="section4__listItem">
              <svg viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_30_1240)">
                  <circle cx="48" cy="48" r="47.5" stroke="#3C1053"/>
                </g>
                <circle cx="48" cy="48" r="42.5" fill="#FFD770" stroke="#3C1053"/>
                <path
                    d="M50.2149 67.3312L24.5365 45.457C24.2148 45.1829 24.1001 44.7362 24.2499 44.3411L28.9727 31.8903C29.2246 31.2263 30.0689 31.0291 30.5888 31.5128L50.3174 49.8651C50.7019 50.2227 51.2975 50.2221 51.6812 49.8636L87.3173 16.572C87.9564 15.9749 89 16.4281 89 17.3027V20.1492C89 20.3763 88.9227 20.5966 88.7809 20.7739L51.6443 67.1947C51.2917 67.6354 50.6445 67.6972 50.2149 67.3312Z"
                    fill="white" stroke="#3C1053"/>
                <defs>
                  <clipPath id="clip0_30_1240">
                    <rect width="48" height="96" fill="white"/>
                  </clipPath>
                </defs>
              </svg>

              <p>Регулярне відвідування
                лікаря</p>
            </div>
          </div>
          <p><span>*Оригінальний (інноваційний) лікарський засіб</span> — <i>лікарський засіб, що був уперше у світі
            зареєстрований на основі повного комплекту документів щодо його якості, безпеки та ефективності (повної
            реєстраційної інформації). (визначення з наказу Міністерства охорони здоров’я України №426 від 26.08.2005
            (зі змінами) у чинній редакції станом на квітень 2023 року).</i></p>
        </div>
      </div>

    </section>

    <section class="section section6">
      <div class="section6__row section6__row--first">
        <div class="container">

          <h2>Учасник програми, якому лікар призначив відповідний лікарський засіб**, може придбати його зі знижкою,
            користуючись карткою учасника програми</h2>
        </div>
      </div>
      <div class="section6__row section6__row--second ">
        <div class="container">
          <div class="section6__table section6__table--desk">

            <table>
              <tr>
                <td class="section6__item-head section6__item-head--first">Діюча речовина</td>
                <td class="section6__item-head">Дозування</td>
                <td class="section6__item-head section6__item-head--last">Розмір знижки для учасників програми</td>
              </tr>

              <tr>
                <td class="section6__item-body section6__item-body--first">
              <span>
            Розувастатин
                </span>
                </td>
                <td class="section6__item-body">
              <span>
              5, 10, 20, 40 мг
              </span></td>
                <td class="section6__item-body section6__item-body--last">
              <span>
              <span class="big">20<span> % </span></span>
              </span></td>
              </tr>

              <tr>
                <td class="section6__item-body section6__item-body--first">
              <span>
            Тикагрелор
                </span>
                </td>
                <td class="section6__item-body">
              <span>
              90, 60 мг
              </span></td>
                <td class="section6__item-body section6__item-body--last">
              <span>
              <span class="big">30<span> % </span></span>
              </span></td>
              </tr>
            </table>

          </div>

          <div class="section6__table section6__table--mob">

            <table>
              <tr>
                <td class="section6__item-head section6__item-head--first">Діюча речовина</td>
              </tr>

              <tr>
                <td class="section6__item-body">
              <span>
             Розувастатин
                </span>
                </td>
              </tr>
            </table>
            <table>
              <tr>
                <td class="section6__item-head">Дозування</td>
              </tr>

              <tr>
                <td class="section6__item-body">
              <span>
        5, 10, 20, 40 мг
              </span>
                </td>
              </tr>
            </table>
            <table>
              <tr>
                <td class="section6__item-head section6__item-head--last">Розмір знижки для учасників програми</td>
              </tr>

              <tr>
                <td class="section6__item-body section6__item-body--last">
              <span>
              <span class="big">20<span> % </span></span>
              </span></td>
              </tr>
            </table>

            <table class="mt60">
              <tr>
                <td class="section6__item-head section6__item-head--first">Діюча речовина</td>
              </tr>

              <tr>
                <td class="section6__item-body">
              <span>
             Тикагрелор
                </span>
                </td>
              </tr>
            </table>
            <table>
              <tr>
                <td class="section6__item-head">Дозування</td>
              </tr>

              <tr>
                <td class="section6__item-body">
              <span>
     90,60 мг
              </span>
                </td>
              </tr>
            </table>
            <table>
              <tr>
                <td class="section6__item-head section6__item-head--last">Розмір знижки для учасників програми</td>
              </tr>

              <tr>
                <td class="section6__item-body section6__item-body--last">
              <span>
              <span class="big">30<span> % </span></span>
              </span></td>
              </tr>
            </table>

          </div>

          <p class="section6__smallText">
            <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M4.44444 0H3.55556V2.92615L1.48584 0.856435L0.857303 1.48497L2.92788 3.55556H0V4.44444H2.92668L0.857066 6.51405L1.48561 7.14259L3.55556 5.07264V8H4.44444V5.07212L6.51416 7.14183L7.1427 6.51329L5.07385 4.44444H8V3.55556H5.07264L7.14246 1.48574L6.51392 0.857201L4.44444 2.92668V0Z"
                    fill="white"/>
            </svg>
            <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M4.44444 0H3.55556V2.92615L1.48584 0.856435L0.857303 1.48497L2.92788 3.55556H0V4.44444H2.92668L0.857066 6.51405L1.48561 7.14259L3.55556 5.07264V8H4.44444V5.07212L6.51416 7.14183L7.1427 6.51329L5.07385 4.44444H8V3.55556H5.07264L7.14246 1.48574L6.51392 0.857201L4.44444 2.92668V0Z"
                    fill="white"/>
            </svg>
            <span>Інформацію щодо лікарських засобів, які беруть участь у програмі «ТерапіяПЛЮС», ви можете знайти на сайті
              <a
                  href="https://www.terapiaplus.com/" target="_blank">www.terapiaplus.com.</a><br>
              Умови програми, зокрема розмір знижок, можуть бути змінені без попередження учасників програми.<br>
              Не змінюйте курс терапії самостійно. Не пропускайте прийом призначених вам препаратів!
            </span>
          </p>
        </div>
      </div>
    </section>

    <section class="section section7">
      <div class="content container">
        <a href="/TerapiaPLUS_patient_pakage_210x148_2025-03___Cardio___001-CHD.pdf" download
           class="section7__download">
          <p>Завантажити матеріали </p>
        </a>
      </div>

    </section>
  </div>
</template>

<style scoped lang="scss">
.IschemicHeartDisease {

  &__banner {
    overflow: hidden;
    position: relative;
    height: 396px;
    // padding: 88px 0 308px;
    background: #69b6c7 url("~@/assets/img/pulmonology/patternt.png") no-repeat center calc(100% - 131px);
    background-size: contain;
    background-position-y: bottom;
    z-index: 1;

    @media (max-width: 1200px) {
      height: 260px;
    }

    @media (max-width: 768px) {
      //background: #69b6c7;
      background: #69b6c7 url("~@/assets/img/MyocardialInfarction/pattern-mob.png") no-repeat right bottom;
      background-size: 93%;

      height: auto;
    }

    &--title {
      font-size: 72px;
      line-height: 80px;
      font-weight: 700;
      color: #fff;
      margin-top: 115px;
      @media (max-width: 1200px) {
        font-size: 56px;
        line-height: 64px;
        margin-top: 40px;
      }
      @media screen and (max-width: 1336px) {
      }
      @media screen and (max-width: 1024px) {

      }
      @media (max-width: 768px) {
        font-size: 48px;
        line-height: 40px;
        padding-left: 20px;
      }
      @media (max-width: 550px) {
        font-size: 32px;

      }

    }
  }

  &__wrapper {
    display: flex;
    justify-content: space-between;
    height: 100%;
    //padding-left: 0;
    //padding-right: 0;

    @media (max-width: 1024px) {
      flex-direction: column;
    }
    @media (max-width: 768px) {
      padding-left: 0;
      padding-right: 0;
    }
    @media (max-width: 400px) {
      padding: 0;
    }

    .right {
      position: absolute;
      right: 0;
      bottom: -4%;
      display: flex;
      justify-content: flex-end;
      width: 100%;

      @media (max-width: 768px) {
        position: relative;
      }

      .img-desc {
        width: auto;
        height: 100%;
        position: relative;

        @media (max-width: 1200px) {
          width: 100%;
          height: auto;
        }
        @media (max-width: 768px) {
          display: none;
        }
      }

      .img-mob {
        display: none;
        width: 100%;
        height: auto;
        @media (max-width: 768px) {
          display: block;
        }
      }
    }
  }

  .section2 {
    width: 100%;
    margin: 0 auto;
    overflow: hidden;


    background: url("~@/assets/img/IschemicHeartDisease/section2_patern.svg") #F0F8FA no-repeat center bottom;
    background-size: 100% 100%;

    @media screen and (max-width: 991px) {
      background: #F0F8FA;
    }

    .container {
      padding-top: 152px;
      padding-bottom: 152px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      position: relative;
      z-index: 1;


      @media screen and (max-width: 1440px) {

        padding-top: 100px;
        padding-bottom: 100px;
      }

      @media screen and (max-width: 1200px) {
        padding-top: 80px;
        padding-bottom: 80px;

      }

      @media screen and (max-width: 991px) {
        flex-direction: column;
        padding-top: 48px;
        padding-bottom: 48px;
      }
    }

    &__col {
      max-width: 680px;
      width: 100%;
      margin-top: 15px;
      min-width: 500px;
      @media screen and (max-width: 1200px) {
        min-width: 1px;
        max-width: 500px;
      }

      @media screen and (max-width: 991px) {
        max-width: 100%;
      }

      h1 {
        color: var(--Purple, #3C1053);

        font-size: 48px;
        font-style: normal;
        font-weight: 700;
        line-height: 64px;
        margin-bottom: 70px;
        @media screen and (max-width: 1200px) {
          font-size: 32px;
          line-height: 40px;
          margin-bottom: 20px;
        }
      }

      p {
        color: var(--Purple, #3C1053);
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 36px;
        margin-bottom: 24px;

        @media screen and (max-width: 1200px) {
          font-size: 18px;
          line-height: 28px;
          margin-bottom: 18px;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    &__img {
      max-width: calc(100% - 680px);
      display: flex;
      justify-content: center;
      width: 100%;

      @media screen and (max-width: 1200px) {
        max-width: calc(100% - 500px);
      }

      @media screen and (max-width: 991px) {
        max-width: 60%;
      }

      @media screen and (max-width: 600px) {
        max-width: 80%;
      }

      @media screen and (max-width: 425px) {
        max-width: 100%;
      }

      img {
        max-width: 577px;
        min-width: 1px;
        width: 100%;
        height: auto;
        display: block;
        margin-left: 16%;

        @media screen and (max-width: 1200px) {
          max-width: 380px;
          margin-left: 0;
        }
        @media screen and (max-width: 991px) {
          max-width: 100%;
          margin-left: 0;
          margin-top: 40px;
        }
      }
    }
  }

  .section3 {
    width: 100%;
    margin: 0 auto;
    overflow: hidden;

    background: url("~@/assets/img/IschemicHeartDisease/section3_patern.svg") #F0F8FA no-repeat center bottom;
    background-size: 100% 100%;

    .container {
      padding-top: 152px;
      padding-bottom: 152px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;
      z-index: 1;


      @media screen and (max-width: 1440px) {

        padding-top: 100px;
        padding-bottom: 100px;
      }

      @media screen and (max-width: 1200px) {
        padding-top: 80px;
        padding-bottom: 80px;

      }

      @media screen and (max-width: 991px) {
        background: #F0F8FA;
        flex-direction: column-reverse;
        padding-top: 48px;
        padding-bottom: 48px;
      }
    }

    &__col {
      max-width: 707px;
      width: 100%;
      margin-top: 15px;
      min-width: 500px;

      &--right {
        margin-left: 16%;
      }

      @media screen and (max-width: 1200px) {
        min-width: 1px;
        max-width: 500px;
      }

      @media screen and (max-width: 991px) {
        max-width: 100%;
        margin-left: 0;
      }

      h1 {
        color: var(--Purple, #3C1053);
        font-size: 48px;
        font-style: normal;
        font-weight: 700;
        line-height: 64px;
        margin-bottom: 70px;
        @media screen and (max-width: 1200px) {
          font-size: 32px;
          line-height: 40px;
          margin-bottom: 20px;
        }
      }

      p {
        color: var(--Purple, #3C1053);
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 36px;
        margin-bottom: 24px;

        @media screen and (max-width: 1200px) {
          font-size: 18px;
          line-height: 28px;
          margin-bottom: 18px;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    &__img {
      display: flex;
      justify-content: center;
      max-width: 680px;
      width: 100%;

      @media screen and (max-width: 1200px) {
        max-width: calc(100% - 500px);
      }

      @media screen and (max-width: 991px) {
        max-width: 60%;
      }

      @media screen and (max-width: 600px) {
        max-width: 80%;
      }

      @media screen and (max-width: 425px) {
        max-width: 100%;
      }

      img {
        max-width: 524px;
        min-width: 1px;
        width: 100%;
        height: auto;
        display: block;
        margin-left: 14%;

        @media screen and (max-width: 1200px) {
          max-width: 380px;
        }
        @media screen and (max-width: 991px) {
          max-width: 100%;
          margin-top: 40px;

        }
      }
    }
  }

  .section4 {

    padding: 152px 0;

    background: url("~@/assets/img/MyocardialInfarction/section4_pattern.svg") white no-repeat center bottom;
    background-size: 100%;

    @media screen and (max-width: 1440px) {
      padding: 100px 0;
    }

    @media screen and (max-width: 1200px) {
      padding: 80px 0;
    }

    @media screen and (max-width: 991px) {
      padding: 48px 0;
      background: white;
    }

    .container {
      display: flex;
      justify-content: space-between;
      @media screen and (max-width: 991px) {
        flex-direction: column;
      }
    }

    &__col {
      max-width: 680px;
      width: 100%;
      @media screen and (max-width: 991px) {
        max-width: 100%;
      }

      &--left {
        margin-right: 25px;

        @media screen and (max-width: 991px) {
          margin-right: 0;
        }

        h3 {
          color: var(--Purple, #3C1053);
          font-size: 48px;
          font-weight: 700;
          line-height: 64px;
          margin-bottom: 21px;
          @media screen and (max-width: 1200px) {
            font-size: 32px;
            line-height: 40px;
            margin-bottom: 20px;
          }
        }

        p {
          color: var(--Purple, #3C1053);
          font-size: 24px;
          font-style: normal;
          font-weight: 400;
          line-height: 36px;
          margin-bottom: 24px;
          @media screen and (max-width: 1200px) {
            font-size: 18px;
            line-height: 28px;
            margin-bottom: 20px;
          }


          &:last-child {
            margin-bottom: 0;
          }

          span {
            font-weight: 700;
          }
        }
      }

      &--right {
        margin-left: 25px;
        @media screen and (max-width: 991px) {
          margin-left: 0;
          margin-top: 95px;
        }
        @media screen and (max-width: 425px) {
          margin-top: 48px;
        }

        h4 {
          color: #69B6C7;
          font-size: 38px;
          font-weight: 700;
          line-height: 46px;
          margin-bottom: 56px;
          @media screen and (max-width: 1200px) {
            font-size: 32px;
            line-height: 40px;
            margin-bottom: 32px;
          }
        }

        p {

          span {
            color: var(--Purple, #3C1053);
            font-size: 16px;
            font-weight: 600;
            line-height: 24px;
          }

          i {
            font-style: italic;
            color: var(--Purple, #3C1053);
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
          }
        }
      }
    }

    &__row {
      display: flex;
      align-items: flex-end;
      justify-content: center;
      flex-direction: column;
      @media screen and (max-width: 600px) {
        align-items: flex-start;
      }

    }

    &__listItem {
      display: flex;
      align-items: center;
      margin-bottom: 40px;
      @media screen and (max-width: 991px) {
        //flex-direction: column;
      }
      @media screen and (max-width: 600px) {
        flex-direction: column;
        align-items: flex-start;
      }

      svg {
        width: 96px;
        height: auto;
        display: block;
        margin-right: 45px;

        @media screen and (max-width: 1200px) {
          width: 68px;
          margin-right: 24px;
        }
        @media screen and (max-width: 600px) {
          margin-right: 0;
          margin-bottom: 10px;
        }
      }

      p {
        color: var(--Purple, #3C1053);
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 36px;
        max-width: 317px;
        width: 100%;
        @media screen and (max-width: 1200px) {
          font-size: 20px;
          line-height: 28px;
        }
      }
    }
  }

  .section5 {
    padding-top: 152px;

    background: url("~@/assets/img/MyocardialInfarction/section5_pattern.svg") white no-repeat center bottom;
    background-size: 100%;

    @media screen and (max-width: 1440px) {
      padding-top: 100px;
    }

    @media screen and (max-width: 1200px) {
      padding-top: 80px;
    }

    @media screen and (max-width: 991px) {
      padding: 48px 0;
      background: white;
    }

    .swiper {
      @media screen and (max-width: 600px) {
      }
    }

    &__rowText {
      display: flex;
      justify-content: space-between;
      align-items: center;
      @media screen and (max-width: 1024px) {
        margin-bottom: 32px;
      }

      @media screen and (max-width: 991px) {
        flex-direction: column;
      }

      h3 {
        color: var(--Purple, #3C1053);

        font-size: 48px;
        font-style: normal;
        font-weight: 700;
        line-height: 64px;
        margin-right: 50px;
        max-width: 680px;
        width: 100%;
        display: block;
        @media screen and (max-width: 1200px) {
          font-size: 32px;
          line-height: 40px;
        }
        @media screen and (max-width: 991px) {
          margin-right: 0px;
          max-width: 100%;
          margin-bottom: 20px;
          text-align: left;
        }
      }

      p {
        color: var(--Purple, #3C1053);
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 36px; /* 150% */
        max-width: 968px;
        width: 100%;
        @media screen and (max-width: 1200px) {
          font-size: 18px;
          line-height: 28px;
        }
      }
    }

    &__row {

      max-width: 1920px;
      padding: 120px 0 120px 0;

      display: grid;

      grid-gap: 130px;

      grid-template-columns: 1fr 1fr 1fr 1fr;

      @media screen and (max-width: 1700px) {
        grid-gap: 100px;
      }
      @media screen and (max-width: 1445px) {
        grid-gap: 80px;
      }
      @media screen and (max-width: 1350px) {
        grid-gap: 40px;
      }
      @media screen and (max-width: 1200px) {
        padding: 80px 0;
      }

      &--desk {
        @media screen and (max-width: 1024px) {
          display: none;
        }
      }
    }

    &__item {

      display: flex;
      flex-direction: column;


      &-num {
        color: #70C2D4;

        font-size: 72px;
        font-style: normal;
        font-weight: 700;
        line-height: 88px; /* 122.222% */

        margin-top: -88px;
        margin-bottom: 8px;

        @media (max-width: 1440px) {
          font-size: 62px;
        }
        @media screen and (max-width: 1200px) {
          font-size: 58px;
        }
        @media screen and (max-width: 1024px) {
          font-size: 52px;
        }
      }

      &-text {
        color: var(--Purple, #3C1053);

        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 36px;

        @media (max-width: 1440px) {
          font-size: 22px;
          line-height: 140%;
        }
        @media screen and (max-width: 1200px) {
          font-size: 20px;
        }

        @media screen and (max-width: 1024px) {
          font-size: 20px;
          line-height: 28px; /* 140% */
        }
      }

      svg {
        margin: 0 0 10px auto;
        max-width: 62.1%;
        width: 100%;
        height: auto;

        display: block;

        @media screen and (max-width: 600px) {
          max-width: 200px;
        }
      }
    }

    .mySwiper {
      display: none;
      //max-width: 480px;
      margin: 0 auto;
      //padding-bottom: 40px;
      padding: 0 0 80px 0;
      @media screen and (max-width: 1024px) {
        display: block;
      }
      @media screen and (max-width: 425px) {
        padding: 0 0 40px 0;
      }

      ::v-deep(.swiper-pagination-bullet) {
        border: 1px solid #63B3CD;
        background: white;
        opacity: 1;
        bottom: 48px;

        &.swiper-pagination-bullet-active {
          background: #63B3CD;
          width: 8px;
          height: 8px;
        }
      }
    }

    &__title {
      color: var(--Purple, #3C1053);

      font-size: 32px;
      font-weight: 700;
      line-height: 40px;
      margin-bottom: 32px;

      &--mobile {

        display: none;
        @media screen and (max-width: 1024px) {
          display: block;
        }
      }
    }
  }

  .section6 {

    &__row {

      &--first {
        padding: 150px 0 220px 0;

        background: url("~@/assets/img/pulmonology/section6-bg.png") #FFEEC3 repeat-x left top;
        background-size: contain;


        @media screen and (max-width: 1024px) {
          margin-right: 0;
          padding: 48px 20px 100px 20px;

          background: url("~@/assets/img/pulmonology/section6-bg.png") #FFEEC3 repeat-x left top;
          background-size: cover;
        }

        .container {
          padding-left: 0;
          padding-right: 0;
        }

        h2 {
          color: var(--Purple, #3C1053);
          text-align: center;
          width: 80%;
          margin: 0 auto;

          font-size: 48px;
          font-style: normal;
          font-weight: 700;
          line-height: 64px;
          @media (max-width: 1440px) {
            width: 100%;
            font-size: 42px;
            line-height: 52px;
          }

          @media screen and (max-width: 1024px) {
            font-size: 32px;
            width: 100%;
            line-height: 40px; /* 125% */
            text-align: left;
          }
        }
      }

      &--second {
        background: #69B6C7;
        padding: 0 0 150px 0;


        @media screen and (max-width: 1024px) {
          padding: 0 20px 48px 20px;
        }

        .container {
          padding-left: 0;
          padding-right: 0;
        }
      }
    }

    &__table {

      width: 100%;
      margin: 0 auto 0 auto;
      top: -120px;
      position: relative;

      @media screen and (max-width: 1024px) {
        top: -60px;
      }

      .mt60 {
        margin-top: 60px;
      }

      &--mob {
        display: none;
        @media screen and (max-width: 1024px) {
          display: block;
        }
      }

      &--desk {
        @media screen and (max-width: 1024px) {
          display: none;
        }
      }

      table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;
        border: 1px dashed #FFF;

        @media screen and (max-width: 1024px) {
          margin-bottom: 12px;
        }

        td {
          width: calc(100% / 3);
          @media screen and (max-width: 1024px) {
            width: 100%;

          }
        }
      }
    }

    &__item {
      //height: fit-content;

      &-head {
        color: #FFF;
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 28px;

        //border-top: 1px dashed #FFF;
        border-left: 1px dashed #FFF;
        background: #69B6C7;
        margin-bottom: 0;
        padding: 32px 20px;
        text-align: center;

        &--first {
          border-left: none;
        }

        @media screen and (max-width: 1024px) {
          line-height: 16px;
          font-size: 16px;

          padding: 10px 20px;
          //border-top: 1px dashed #FFF;
          //border-left: 1px dashed #FFF;
          //border-right: 1px dashed #FFF;
        }

        &--last {
          //border-right: 1px dashed #FFF;
        }
      }

      &-body {
        border-top: 1px dashed #69B6C7;
        border-left: 1px dashed #69B6C7;
        //border-bottom: 1px dashed #69B6C7;
        background: var(--White, #FFF);

        padding: 52px 20px;
        height: 100%;
        text-align: center;

        @media screen and (max-width: 1024px) {
          border-left: none;
          padding: 32px 20px;
        }

        > span {
          color: var(--Purple, #3C1053);
          font-size: 34px;
          font-style: normal;
          font-weight: 400;
          line-height: 36px; /* 105.882% */

          .mt {
            color: var(--Purple, #3C1053);
            font-size: 34px;
            font-style: normal;
            font-weight: 400;
            line-height: 36px;

            display: inline-block;

            padding-top: 20px;

            @media screen and (max-width: 1024px) {
              font-size: 24px;
              line-height: 36px;
            }
          }

          span {
            color: #69B6C7;
            font-size: 44px;
            font-style: normal;
            font-weight: 400;
            line-height: 36px; /* 81.818% */

            &.top {
              position: relative;
              top: 4px;
              //@media screen and (max-width: 1024px) {
              //  top: 10px;
              //}
            }

            @media screen and (max-width: 1024px) {
              font-size: 44px;
              line-height: 36px;
            }

            &.big {
              color: #69B6C7;
              font-size: 58px;
              font-style: normal;
              font-weight: 700;
              line-height: 64px; /* 110.345% */

              @media screen and (max-width: 1024px) {
                font-size: 58px;
                line-height: 64px;
              }

              span {
                font-size: 42px;
                line-height: 40px; /* 95.238% */

                font-weight: 700;

              }
            }
          }

          @media screen and (max-width: 1024px) {
            font-size: 24px;
            line-height: 36px;
          }
        }

        &--last {
          //border-right: 1px dashed #69B6C7;
        }

        &--first {
          border-left: none;
        }
      }

    }

    &__smallText {
      max-width: 1680px;
      width: 100%;
      margin: -80px auto 0 auto;

      color: #FFF;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;

      display: flex;
      align-items: flex-start;

      @media screen and (max-width: 1024px) {
        margin: -40px auto 0 auto;
        font-size: 14px;
        line-height: 16px;
      }

      svg {
        min-width: 8px;
        height: auto;
        display: inline-block;
        position: relative;
        top: 6px;
        margin-right: 8px;

        @media screen and (max-width: 1024px) {
          top: 4px;
        }

        &:first-child {
          margin-right: 0;
        }
      }

      a {
        color: #FFF;
        font-size: 16px;
        font-weight: 700;
        text-decoration-line: underline;
        @media screen and (max-width: 1024px) {
          font-size: 14px;
        }
      }
    }
  }

  .section7 {

    background: rgba(105, 182, 199, 0.1);


    .content {

      padding: 100px 0;

      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      @media screen and (max-width: 1024px) {
        padding: 60px 20px 48px 20px;
      }

    }

    a {
      display: flex;
      align-items: center;
      justify-content: center;

      text-decoration: none;
      border-radius: 2px;
      border: 1px solid var(--Purple, #3C1053);
      background: #70C2D4;
      padding: 24px 44px;
      @media screen and (min-width: 1024px) {
        &:hover {
          background: #C4D600;
        }
      }

      &:active {
        background: #C4D600;
      }

      @media screen and (max-width: 1024px) {
      }
      @media screen and (max-width: 425px) {
        padding: 24px;
      }

      p {
        color: var(--Purple, #3C1053);
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        letter-spacing: 1.26px;
        text-transform: uppercase;
        @media screen and (max-width: 1024px) {
          font-size: 14px;
          letter-spacing: 0.98px;
        }
      }
    }

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 0;
      pointer-events: none;
      z-index: 10;
    }

    &__videoWrapper {
      position: relative;
      padding-bottom: 56.25%; /* 16:9 */
      width: 100%;
      height: 0;
      overflow: hidden;


      iframe {
        position: absolute;
        z-index: 20;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>